export const breakpoints = {
  max: 960,
}
